import Rx from 'rxjs';
import { combineEpics } from 'redux-observable';

import * as constAction from 'root/actionConstants';
import * as feriadosActions from 'modules/feriados/action';
import * as generalActions from 'modules/general/action';
import * as errorActions from 'modules/error/action';
import { request } from 'core/generalFunctions';

const { ajax } = Rx.Observable;

export const getEpic = (action$, store) =>
action$.ofType(constAction.FERIADOS_GET)
.switchMap(action =>
  ajax(request(action))
  .map(result => feriadosActions.setState({lista: result.response}))
  .catch(err => errorActions.request(err, action))
  .startWith(generalActions.loadingbar_show())
  .finally(() => store.dispatch(generalActions.loadingbar_hide()))
);

export const setEpic = (action$, store) =>
action$.ofType(constAction.FERIADOS_SET)
.throttleTime(2000)
.switchMap(action =>
  ajax(request(action))
  .map(result => feriadosActions.setStateById(result.response))
  .concat(Rx.Observable.of(generalActions.snackbar_show('Feriado guardado')))
  .catch(err => errorActions.request(err, action))
  .startWith(generalActions.loadingbar_show())
  .finally(() => store.dispatch(generalActions.loadingbar_hide()))
);

export const deleteEpic = (action$, store) =>
action$.ofType(constAction.FERIADOS_DELETE)
.throttleTime(500)
.switchMap(action =>
  ajax(request(action))
  .mapTo(generalActions.snackbar_show('Feriado eliminado'))
  .catch(err => errorActions.request(err, action))
  .startWith(generalActions.loadingbar_show())
  .finally(() => store.dispatch(generalActions.loadingbar_hide()))
);

export default combineEpics(getEpic, setEpic, deleteEpic);



// WEBPACK FOOTER //
// src/modules/feriados/epics.js